export default "__VITE_ASSET__f3003b74__"